import maintenanceClient from "../api/maintenanceClient";

export function getMaintenanceInfo(successCallback, errorCallback) {
  maintenanceClient
    .get("/maintenance")
    .then((response) => {
      return response.data;
    })
    .then((data) => {
      successCallback(data);
    })
    .catch((error) => {
      errorCallback(error);
    });
}
